import FormSelectField from "../../forms/fields/basic/SelectField";
import ConnectionFormDialog from "../../forms/ConnectionFormDialog";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import { ConnectionFormDataController } from "../../../controllers/formController";
import { Team } from "../../../types/team";
import renderTeamSelection from "../../entitiesReferences/SelectionModals/TeamSelectionModal";
import renderPersonSelection from "../../entitiesReferences/SelectionModals/PersonSelectionModal";
import AccordionSubFormContainer from "../../forms/fields/subForms/accordion/AccordionSubFormContainer";
import AccordionSubForm from "../../forms/fields/subForms/accordion/AccordionSubForm";
import NameInternalEvidence from "../../forms/common/subForms/NameInternalEvidence";
import NameExternalEvidence from "../../forms/common/subForms/NameExternalEvidence";
import { Person } from "../../../types/person";
import { TeamMember } from "../../../types/teamMember";
import useTeamMemberLogic from "../../../hooks/logic/connections/teamMemberLogic";

interface TeamMemberDialogProps {
  systemLanguageType: TeamMember["system_language_type"];
  controller: ConnectionFormDataController<TeamMember, Team, Person>;
}

const TeamMemberDialog: React.FC<TeamMemberDialogProps> = ({
  controller,
  systemLanguageType,
}) => {
  const { roleEnum, teamMemberStatusEnum } = useTeamMemberLogic(
    controller.from,
    controller.to,
    systemLanguageType
  );

  return (
    <ConnectionFormDialog<TeamMember, Team, Person>
      fromLabel="Team"
      fromEntityCollection={SystemEntityCollections.TEAM}
      toLabel="Person"
      toEntityCollection={SystemEntityCollections.PERSON}
      renderFromEntitySelection={renderTeamSelection(systemLanguageType)}
      renderToEntitySelection={renderPersonSelection}
      controller={controller}
    >
      <FormSelectField
        name="status"
        label="Status"
        placeholder="Select Status"
        useEnum={teamMemberStatusEnum}
      />
      <FormSelectField
        name="role"
        label="Role"
        placeholder="Select Role"
        useEnum={roleEnum}
      />
      <AccordionSubFormContainer>
        <AccordionSubForm
          name="name_internal_evidence"
          label="Name Internal Evidence"
        >
          <NameInternalEvidence />
        </AccordionSubForm>
        <AccordionSubForm
          name="name_external_evidence"
          label="Name External Evidence"
        >
          <NameExternalEvidence />
        </AccordionSubForm>
      </AccordionSubFormContainer>
    </ConnectionFormDialog>
  );
};

export default TeamMemberDialog;
